module.exports = __webpack_public_path__ + "static/media/play_icon.4ebcb9ec.svg";